import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Configuration } from "src/assets/Configuration";
import { Observable } from "rxjs";
import { TrainingCreationAndUpdateModel } from "../models/training/training-creation-and-update.model";
import { TrainingTemplateCreationAndUpdateModel } from "../models/training-template/training-template-creation-and-update.model";
import { CourseTemplateCreationAndUpdateBaseModel } from "../models/course/course-template-creation-and-update-base.model";
import { PreviewResponse } from "../models/report-preview/preview-response.model";

@Injectable({
  providedIn: 'root'
})
export class ReportPreviewService {

  constructor(private httpClient: HttpClient) {
  }

   public createTrainingPreview(
    model: TrainingCreationAndUpdateModel
  ): Observable<PreviewResponse> {
    return this.httpClient.post<PreviewResponse>(
      Configuration.getApiBaseUrl() + "/reportpreview/training/preview",
      model
    );
  }

  public createTrainingTemplatePreview(
    model: TrainingTemplateCreationAndUpdateModel
  ): Observable<PreviewResponse> {
    return this.httpClient.post<PreviewResponse>(
      Configuration.getApiBaseUrl() + "/reportpreview/training-template/preview",
      model
    );
  }

  public createCoursePreview(
    model: CourseTemplateCreationAndUpdateBaseModel
  ): Observable<PreviewResponse> {
    return this.httpClient.post<PreviewResponse>(
      Configuration.getApiBaseUrl() + "/reportpreview/course/preview",
      model
    );
  }
}